import { defineMessages } from 'react-intl';

export default defineMessages({
  defaultActorInfoTitle: {
    id: 'view.procedure.defaultActorInfoTitle',
    defaultMessage: 'Contact info',
  },
});
